/* eslint-disable no-mixed-spaces-and-tabs */
import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import { useState } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { fetchBroadcastHistory } from "../../../../../../export/scheduler";
import Tabs from "../../../../../../ts/design/wilya-tabs";
import DialogWrapper from "../../../../../design/dialog-wrapper";
import ActionButtons from "./action-buttons";
import BMessageForm from "./bmessage-form";
import BMessageHistory from "./bmessage-history";
import useBmessageDialog from "./controllers/use-bmessage-dialog";

export const dialogTitle = "Broadcast Message";
export const dialogSubtitle =
	"Notify your team via text and in-app notifications.";
export const SEND_MESSAGE = "Send Message";
export const HISTORY = "Message History";

interface BroadcastMessageDialogProps {
	handleClose: () => void;
	open: boolean;
}

const BroadcastMessageDialog: React.FC<BroadcastMessageDialogProps> = ({
	handleClose,
	open,
}) => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [
		{
			jobs,
			message,
			options,
			filteredJobs,
			filteredWorkcenters,
			workerTypeOptions,
			shiftPatternOptions,
			isShiftPatternEnabled,
		},
		{
			setMessage,
			handleClick,
			handleSelectAll,
			setOptions,
			setFilteredWorkcenters,
			setFilteredJobs,
			setWorkerTypeOptions,
			setShiftPatternOptions,
			setChangedBy,
		},
	] = useBmessageDialog();
	const [selectedTab, setSelectedTab] = useState(SEND_MESSAGE);
	const sendMessageLabel = t("scheduler_send-message");
	const historyLabel = t("scheduler_message-history");

	const listOfTabs = [
		<BMessageForm
			key='bMessageForm'
			jobs={jobs ?? {}}
			message={message ?? ""}
			setMessage={
				setMessage
					? setMessage
					: () => {
							// Do nothing
					  }
			}
			handleClick={
				handleClick
					? handleClick
					: () => {
							// Do nothing
					  }
			}
			handleSelectAll={
				handleSelectAll
					? handleSelectAll
					: () => {
							// Do nothing
					  }
			}
			options={options ?? []}
			workcenters={filteredWorkcenters ?? []}
			setWorkcenters={
				setFilteredWorkcenters
					? setFilteredWorkcenters
					: () => {
							// Do nothing
					  }
			}
			setOptions={
				setOptions
					? setOptions
					: () => {
							// Do nothing
					  }
			}
			filteredJobs={filteredJobs ?? []}
			setFilteredJobs={
				setFilteredJobs
					? setFilteredJobs
					: () => {
							// Do nothing
					  }
			}
			workerTypeOptions={workerTypeOptions ?? []}
			setWorkerTypeOptions={
				setWorkerTypeOptions
					? setWorkerTypeOptions
					: () => {
							// Do nothing
					  }
			}
			shiftPatternOptions={shiftPatternOptions ?? []}
			setShiftPatternOptions={
				setShiftPatternOptions
					? setShiftPatternOptions
					: () => {
							// Do nothing
					  }
			}
			isShiftPatternEnabled={isShiftPatternEnabled === true}
			setChangedBy={
				setChangedBy
					? setChangedBy
					: () => {
							// Do nothing
					  }
			}
		/>,
		<BMessageHistory key='bMessageHistory' />,
	];
	return (
		<Dialog
			onClose={(event, reason) => {
				if (reason !== "backdropClick" && handleClose) {
					handleClose();
				}
			}}
			aria-labelledby='add-new-shift'
			open={open}
			fullWidth
			PaperProps={{ sx: { maxWidth: "1200px" } }}
		>
			<DialogWrapper
				dialogTitle={t("scheduler_broadcast-message")}
				dialogSubTitle={t("scheduler_broadcast-message-subtitle")}
				dialogContent={
					<Tabs
						tabPanelList={listOfTabs}
						tabPanelLabel={[sendMessageLabel, historyLabel]}
						onClickHandlers={{
							[sendMessageLabel]: () => {
								setSelectedTab(SEND_MESSAGE);
							},
							[historyLabel]: () => {
								setSelectedTab(HISTORY);
								dispatch(fetchBroadcastHistory());
							},
						}}
					/>
				}
				actionButtons={
					selectedTab === SEND_MESSAGE ? (
						<ActionButtons
							handleClose={handleClose}
							jobs={
								filteredJobs
									? filteredJobs.length > 0
										? filteredJobs
												?.filter((job: { checked: boolean }) => job.checked)
												?.map((job: { id: number }) => job.id)
												?.join(",") ?? ""
										: ""
									: ""
							}
							message={message ?? ""}
							locationIds={
								options
									?.filter((option) => option.checked)
									?.map((option) => option.id)
									?.join(",") ?? ""
							}
							workCenterIds={
								filteredWorkcenters
									?.filter((workcenter) => workcenter.checked)
									?.map((workcenter) => workcenter.id)
									?.join(",") ?? ""
							}
							workerTypeIds={
								workerTypeOptions
									?.filter((option) => option.checked)
									?.map((option) => option.id)
									?.join(",") ?? ""
							}
							shiftPatternIds={
								shiftPatternOptions
									?.filter((option) => option.checked)
									?.map((option) => option.id)
									?.join(",") ?? ""
							}
						/>
					) : (
						<Button variant='text' color='primary' onClick={handleClose}>
							{t("common_close")}
						</Button>
					)
				}
			/>
		</Dialog>
	);
};

export default BroadcastMessageDialog;
